import { DISABLE_ANALYTICS, ENV_MODE } from "../../constants";

// send google analytics events
export const sendGA4Event = (data) => {
    const { eventData } = data;
    const { event, trackingData = {} } = eventData || {}

    if (DISABLE_ANALYTICS === 'TRUE') {
        console.warn("Project Analytics is Disabled");
        return;
    }

    if (!event) {
        console.warn("Google Analytics - EventName is mandatory");
        return;
    }

    if (
        (typeof window !== "undefined" && window.gtag) &&
        ENV_MODE === 'production'
    ) {
        window.gtag("event", event, trackingData);
    } else {
        console.warn("Google Analytics is not initialized");
    }
}